import React from 'react'
import styles from './head-nav.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const HeadNav = ({ classes, children, className }) => (
  <ul className={classNames(classes.container, className)}>{children}</ul>
)

export default injectSheet(styles)(HeadNav)
